import { render, staticRenderFns } from "./EscalationAlert.vue?vue&type=template&id=1e673702&scoped=true"
import script from "./EscalationAlert.vue?vue&type=script&lang=ts"
export * from "./EscalationAlert.vue?vue&type=script&lang=ts"
import style0 from "./EscalationAlert.vue?vue&type=style&index=0&id=1e673702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e673702",
  null
  
)

export default component.exports